window.addEventListener('DOMContentLoaded', function() {
  // Thực hiện các thao tác get element ở đây sau khi trang đã được tải hoàn toàn
  var collapsibleBtns = document.querySelectorAll('.collapsible-btn');
  $('body').on('click','.collapsible-btn',function (params) {
    this.parentElement.classList.toggle('active');
  })
  var testimonial = $('body').find('.testimonial-slider');
  $(document).on('pjax:success', function() {
    let ajaxload = $('body').find('.testimonial-slider');
    init_slick(ajaxload);
  });
  init_slick(testimonial);
    function init_slick(name) {
      $(name).slick({
    infinite: true,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:'<span class="PrevArrow"></span>',
    nextArrow:'<span class="NextArrow"></span>', 
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
  });
    }
  
});

